<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <mat-form-field>
    <input
      matInput
      formControlName="titolo"
      [placeholder]="'Titolo' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="descrizione"
      [placeholder]="'Descrizione' | translate">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'Tipo elemento' | translate }}</mat-label>
    <mat-select formControlName="className">
      <mat-option></mat-option>
      <mat-option
        *ngFor="let type of iterableCollectionClassNameLabels"
        [value]="type.value">
        {{ type.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
